export default {
  transaccionality: null,
  holdingTransaccionality: null,
  transactionalityPagination: null,
};
